import { SearchResult, SearchResultsGroup } from '@interfaces/search-result.interface';

export type SearchResultGroupKey = keyof SearchResultsGroup;

export const flattenSearchResults = (results: SearchResultsGroup): SearchResult[] => {
  return [...results.folders, ...results.products, ...results.news];
};

export const globalSearchResultIndex = (
  results: SearchResultsGroup,
  group: SearchResultGroupKey,
  localIndex: number
): number => {
  if (group === 'folders') {
    return localIndex;
  }
  if (group === 'products') {
    return results.folders.length + localIndex;
  }
  return results.folders.length + results.products.length + localIndex;
};

export const isSearchResultActive = (
  activeIndex: number,
  results: SearchResultsGroup,
  group: SearchResultGroupKey,
  localIndex: number
): boolean => {
  return activeIndex === globalSearchResultIndex(results, group, localIndex);
};

export const nextActiveSearchIndex = (activeIndex: number, itemCount: number, delta: number): number => {
  if (itemCount === 0) {
    return -1;
  }
  if (activeIndex < 0) {
    return 0;
  }
  return Math.max(0, Math.min(itemCount - 1, activeIndex + delta));
};
